import { Spinner } from 'react-bootstrap';
import React from 'react';

export function Loading({ text = 'Загрузка...' }) {
    return (
        <div className="app-loading">
            <div className="text-center">
                <Spinner as="span" animation="border" variant="primary" role="status" aria-hidden="true" />
                <span className="text-primary h3 ml-3">{text}</span>
            </div>
        </div>
    );
}
